import App from "app/App";
import { userRoutes } from "config/routes";
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import * as Cookie from "js-cookie";
import authenticationService from "services/common-services/authentication-service";
import { ROLL_CALL_MASTER_ROUTE } from "config/route-consts";

export const PrivateRoute = ({ ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      const currentUser = authenticationService.currentUserValue;
      const token = Cookie.get("Token");
      if (!currentUser && !token) {
        return (
          <Redirect
            to={{
              pathname: `/login`,
              state: { from: props.location },
            }}
          />
        );
      }
      return (
        <React.Suspense fallback={null}>
          <App>
            <Switch>
              <Route
                exact
                path={`/`}
                render={() => {
                  return <Redirect to={ROLL_CALL_MASTER_ROUTE} />;
                }}
              />
              {userRoutes.map(({ path, component: Component }) => (
                <Route
                  key={path}
                  path={path}
                  render={(props) => {
                    return <Component />;
                  }}
                ></Route>
              ))}
            </Switch>
          </App>
        </React.Suspense>
      );
    }}
  />
);
